module.exports = __webpack_public_path__ + "img/nodata.c222ccaf.png";